import { render, staticRenderFns } from "./aiDisclaimerDialog.vue?vue&type=template&id=0fbdd88b&scoped=true"
import script from "./aiDisclaimerDialog.vue?vue&type=script&lang=js"
export * from "./aiDisclaimerDialog.vue?vue&type=script&lang=js"
import style0 from "./aiDisclaimerDialog.vue?vue&type=style&index=0&id=0fbdd88b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdd88b",
  null
  
)

export default component.exports